const API_PATH = {
  //calender
  CALENDAR: "calendar",

  //satsang-sevak
  SATSANG_SEVAK_YEAR: "satsang-sevak/year",
  SATSANG_SEVAK_LIST: "satsang-sevak/list",
  SATSANG_SEVAK_LIST_RECENT: "satsang-sevak/recent",

  //header-menu
  MENU: "menu",

  //event-imagex
  EVENT_IMAGE_YEARS: "event/year",
  EVENT_IMAGE_LIST: "event",
  EVENT_IMAGE_LIST_RECENT: "event/recent",
  EVENT_IMAGES_LIST: "/event/events",

  //sub-events
  SUB_EVENT_LIST: "sub-event",

  //event-media
  EVENT_MEDIA_LIST: "event-media",

  //master
  MASTER: "imp-text/master",

  //daily darshan
  DAILY_DARSHAN: "daily-darshan",
  AVAILBALE_DATES: "daily-darshan/date",

  // books dev-nirav
  SAD_GRANTH: "book",

  //satsang-media
  SATSANG_MEDIA: "satsang-media",
  SATSANG_MEDIA_RING_TONE: "satsang-media/ring_tone",

  //news
  NEWS: "article/news",
  NEWS_YEAR: "article/array/date/news",
  BLOG: "article/blog",
  ARTICLE: "article",
  DOHA_CHOPAI: "doha-chopai",

  //home
  HOME: "home",

  //kirtanLyrics
  KIRTAN_LYRICS: "kirtan-lyrics",
  KIRTAN_LYRICS_SYNC: "kirtan-lyrics/export",
  KIRTAN_CHARACTERS: "kirtan-lyrics/char",

  //SMK : auth endpoints
  AUTH_LOGIN: "auth/login",
  VERIFY_OTP: "auth/verify-otp",
  RESEND_OTP: "auth/resend-otp",
  SET_PASSWORD: "auth/set-password",
  VERIFY_PASSWORD: "auth/password-verify",
  CHANGE_PASSWORD: "auth/resetPassword",
  LOGOUT: "auth/logout",
  FORGOT_PASSWORD: "auth/forgot-password",
  RESEND_FORGOT_PASSWORD_OTP: "auth/forgot-password/resendOtp",
  VERIFY_FORGOT_OTP: "auth/forgot-password/verifyOtp",
  RESET_PASSWORD: "auth/forgot-password/resetPassword",

  // video categories
  VIDEO_CATEGORY: "playlist/home",
  VIDEO_PLAYLIST_DETAILS_BASE_CATEGORY: "playlist",
  VIDEO_BASE_ON_ID: "playlist/videoId",
  GET_AUDIO_URL: "playlist/get-route",

  //recipe
  RECIPE_LIST: "recipe/list",
  RECIPE_DETAILS: "recipe",
  RECIPE_INGREDIENTS: "recipe-ingredient",

  //myFamily api
  FAMILY_MEMBER: "family-member",
  FAMILY_MASTER: "master",
  SPLIT_MEMBERS: "request/split_family",
  TRANSFER_MEMBERS: "request/transfer_smk_member",
  REMOVE_MEMBERS: "request/remove_smk_member",
  ADD_NON_SMK: "request/add_non_smk_member",
  EDIT_MEMBER: "request/edit_smk_member",
  EDIT_FAMILY_DETAILS: "request/edit_family_details",
  CANCEL_REQUEST: "request/cancel",
  EDIT_NON_SMK_FAMILY: "family",

  //thalbhet api

  THALBHET: "transaction/initiate",
  THALBHET_HISTORY: "/thal-bhet",
  VERIFY_PAYMENT: "transaction/verify",
  DOWNLOAD_PAVATI: "thal-bhet/receipt",

  //quiz apis
  QUIZ: "quiz",
  USER_STATS: "quiz/score",
  UPCOMING_QUIZ: "quiz/upcoming",
  COMPLETED_QUIZ_WITH_LOGIN: "quiz/with-auth-completed",
  COMPLETED_QUIZ_WITHOUT_LOGIN: "quiz/without-auth-completed",
  SUBMIT_QUIZ: "quiz/submit",

  //location
  LOCATION_COUNTRY: "location/countries",
  LOCATION_STATE: "location/states",
  LOCATION_DISTRICT: "location/districts",
  LOCATION_TALUKO: "location/talukas",
  LOCATION_VILLAGE: "location/villages",

  //profile
  CONTENT_USER: "content-user",
  SEARCH_TXT: "typesense",
  SEARCH_HISTORY: "search-history",
  // SEARCH_MODULE: "typesense-module",

  //Live
  LIVE: "live-data",
  // footer
  FOOTER: "footer",

  // recent updates
  RECENT_UPDATES: "recent-updates",

  // dhyan murti
  DHYAN_MURTI: "dhyan-murti",

  // contact us
  CONTACT_US: "contact-us",
  CONTACT_US_KUNDAL_ARTI_TIME: "data-variable/kundal-time",
  CONTACT_US_VADODARA_ARTI_TIME: "data-variable/vadodara-time",
  BHAKTI_TOKEN: "auth/get-bhakti",
  FIREBASE_VERIFY_TOKEN: "auth/verify-firebase-token",

  // FCM Token Management
  FCM_TOKEN_GET: "fcm-token",
  FCM_TOKEN_INSERT: "fcm-token",
  FCM_TOKEN_UPDATE_OLD: "fcm-token/update-old-token",
  FCM_TOKEN_UPDATE_PREFERENCES: "fcm-token/update-notification-preferences",
  FCM_TOKEN_DELETE: "fcm-token",

  // nitya niyam
  NITY_NIYAM: "nitya-niyam",
};

export default API_PATH;
